export default __webpack_public_path__ + "static/media/manaw.99c7fe1b.svg";